module.exports = __webpack_public_path__ + "img/medium_icon.263f04eb.png";